<template>
  <div class="whatsapp-tutorial">
    <div class="whatsapp-tutorial__card" :style="{ 'background-color': getAssets.colors.whatsapp.tutorialCardBackground }">
      <div
        class="whatsapp-tutorial__header"
        :style="{
          'background-color': getAssets.colors.whatsapp.tutorialCardHeaderBackground,
          color: getAssets.colors.whatsapp.tutorialCardHeaderFont
        }"
      >
        como receber ofertas
      </div>
      <div
        class="whatsapp-tutorial__container"
        :class="{
          'whatsapp-tutorial__container--stacked': shouldStack,
          'whatsapp-tutorial__container--no-arrows': shouldHideArrows
        }"
      >
        <div v-for="(step, index) in steps" :key="`step-${index}`" class="whatsapp-tutorial__step-wrapper">
          <whatsapp-tutorial-step :step="step" :is-stacked="shouldStack" />
          <v-icon
            v-if="index < steps.length - 1"
            class="whatsapp-tutorial__arrow"
            :class="{ 'whatsapp-tutorial__arrow--vertical': shouldStack }"
            :style="{ color: getAssets.colors.whatsapp.tutorialCardIcon }"
          >
            {{ shouldStack ? 'arrow_downward' : 'arrow_forward' }}
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { screenTypeMixin } from '@/mixins/screen-type'
import WhatsappTutorialStep from './WhatsappTutorialStep.vue'

export default {
  name: 'WhatsappTutorial',
  components: {
    WhatsappTutorialStep
  },
  mixins: [screenTypeMixin],
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1920
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS', 'GET_WHATSAPP_HIDE_ARROWS_BREAKPOINT', 'GET_WHATSAPP_STACK_BREAKPOINT']),
    getAssets() {
      return this.GET_ASSETS
    },
    hideArrowsBreakpoint() {
      return this.GET_WHATSAPP_HIDE_ARROWS_BREAKPOINT
    },
    stackBreakpoint() {
      return this.GET_WHATSAPP_STACK_BREAKPOINT
    },
    shouldHideArrows() {
      return this.windowWidth <= this.hideArrowsBreakpoint
    },
    shouldStack() {
      return this.windowWidth <= this.stackBreakpoint
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style lang="scss" scoped>
.whatsapp-tutorial {
  position: relative;
  padding-top: 100px;
  margin-top: -100px;
  margin-bottom: 0;
  display: flex;
  justify-content: center;

  &__card {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2), 0 0 10px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 10;
    transform: translateY(100px);
    width: fit-content;
    max-width: 100%;
  }

  &__header {
    padding: 16px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &__container {
    display: flex;
    align-items: stretch;
    gap: 16px;
    flex-wrap: nowrap;
    padding: 20px;
    justify-content: center;
  }

  &__step-wrapper {
    display: contents;
  }

  &__arrow {
    flex-shrink: 0;
    flex-grow: 0;
    align-self: center;
    font-size: 24px;
    background-color: white;
    padding: 8px;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    &--vertical {
      transform: none;
    }
  }

  &__container--stacked {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
    padding: 24px;

    .whatsapp-tutorial-step {
      max-width: 100%;
      min-width: unset;
      width: 100%;
      flex: 0 0 auto;
      align-self: stretch;
    }
  }

  &__container--no-arrows {
    gap: 12px;

    .whatsapp-tutorial__arrow:not(.whatsapp-tutorial__arrow--vertical) {
      display: none;
    }
  }

  &__arrow--vertical {
    transform: none;
  }
}
</style>
